import { FetchResult } from '@apollo/client'
import { client } from '../..'
import {
  ConfirmRankingSeasonMutation,
  ConfirmRankingSeasonMutationVariables,
  Country,
  RankInput,
  SaveRankingMutation,
  SaveRankingMutationVariables,
  TalentsSeasonInput,
} from '../../types'
import { CONFIRM_RANKING_SEASON, SAVE_RANKING, UPDATE_RANKING_SEASON } from './Mutations'
import { LIVE_BOARD_OR_HISTORY, TALENTS_SEASON_SETTINGS, TALENTS_SEASON_YEARS } from './Queries'

export const saveTalentsSeasonRanks = async (
  talentsSeasonId: string,
  ranks: RankInput[],
  companyId: string,
  country: Country,
  year: number,
): Promise<FetchResult<SaveRankingMutation>> => {
  return await client.mutate<SaveRankingMutation, SaveRankingMutationVariables>({
    mutation: SAVE_RANKING,
    variables: {
      companyId,
      talentsSeasonId,
      ranks,
    },
    refetchQueries: [{ query: LIVE_BOARD_OR_HISTORY, variables: { companyId, country, year } }],
  })
}

export const confirmRankingSeason = async (
  companyId: string,
  country: Country,
  year: number,
  talentsSeasonId: string,
): Promise<FetchResult<ConfirmRankingSeasonMutation>> => {
  return await client.mutate<ConfirmRankingSeasonMutation, ConfirmRankingSeasonMutationVariables>({
    mutation: CONFIRM_RANKING_SEASON,
    variables: {
      talentsSeasonId,
    },
    refetchQueries: [
      { query: TALENTS_SEASON_YEARS, variables: { companyId, country } },
      { query: LIVE_BOARD_OR_HISTORY, variables: { companyId, country, year } },
      { query: TALENTS_SEASON_SETTINGS, variables: { companyId, country, year } },
    ],
  })
}

export const updateRankingSeason = async (talentsSeasonInput: TalentsSeasonInput): Promise<FetchResult> => {
  return await client.mutate({
    mutation: UPDATE_RANKING_SEASON,
    variables: {
      talentsSeasonInput,
    },
    refetchQueries: [
      {
        query: TALENTS_SEASON_SETTINGS,
        variables: {
          companyId: talentsSeasonInput.companyId,
          country: talentsSeasonInput.country,
          year: talentsSeasonInput.year,
        },
      },
      {
        query: TALENTS_SEASON_YEARS,
        variables: {
          companyId: talentsSeasonInput.companyId,
          country: talentsSeasonInput.country,
        },
      },
      {
        query: LIVE_BOARD_OR_HISTORY,
        variables: {
          companyId: talentsSeasonInput.companyId,
          country: talentsSeasonInput.country,
          year: talentsSeasonInput.year,
        },
      },
    ],
  })
}
